import { Component } from '@angular/core';
import{SessionHelper} from '../app/components/shared/services/localstorage';
import {LoginService} from './globalservices/login.service';
import{Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  
  title = 'Front-End';
  login=false;
  forgotPassword=false;
  public show_dialog : boolean = false;
  public button_name : any = 'Show Login Form!';
  constructor(public router:Router,public loginService:LoginService) {
    
   }


  ngOnInit() {
          this.loginService.currentStatus.subscribe((login:boolean) => {
            this.login=login;
            this.loginService.changeProfile('');
            console.log("Router",this.login);
           });
          }
  toggle() { 
    this.show_dialog = !this.show_dialog; 
    // CHANGE THE TEXT OF THE BUTTON.
    if(this.show_dialog) 
      this.button_name = "Hide Login Form!";
    else
      this.button_name = "Show Login Form!";
  }
}
